import React from 'react';
import { Form, FormItem } from '../../../../components/Form';
import { Card, EditableInputModal } from '../../../../components';
import { useAgentPrompts } from '../../../../pages/agent/hooks/useAgentPrompts';
import { PROMPT_FIELDS } from './constants';
import type { PromptsFormType } from '../../../../pages/agent/hooks/useAgentPrompts';

type PromptsTabProps = {
  agentId: string;
  disabled?: boolean;
};

export const PromptsTab: React.FC<PromptsTabProps> = ({
  agentId,
  disabled,
}) => {
  const { updating, formKey, savePrompt, formValues, setFormValues } =
    useAgentPrompts(agentId);

  return (
    <Card
      collapsable={false}
      name="agentpage.prompts"
      title=""
      size="unset"
      withOverflow={false}
      contentClassName="flex flex-col gap-y-md"
    >
      <Form initialValue={formValues} onChange={setFormValues} key={formKey}>
        {PROMPT_FIELDS.map(({ name, label }) => (
          <FormItem<PromptsFormType>
            key={name}
            name={name}
            label={label}
            inline={true}
          >
            <EditableInputModal
              multiline
              disabled={disabled || updating}
              readonly
              onSavePrompt={content => savePrompt(name, content)}
            />
          </FormItem>
        ))}
      </Form>
    </Card>
  );
};
